import Model from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'

export default class DistrictCoordinator extends Model {
  [Type] = 'district-coordinator' as const
}
